import React from 'react';

import SpreadsheetIcon from '@atlaskit/icon/core/spreadsheet';
import { token } from '@atlaskit/tokens';

import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../../config-items/config-items';
import { createEditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { Icon } from '../../assets/icons/convertToTable';
import { createInsertBelow, createReplace } from '../../config-item-actions/markdown';
import { isMinLength } from '../../config-item-visible/visibility-utils';

import { messages } from './messages';

const intentSchemaId = 'convert_to_table.json';

export const convertToTable: EditorPluginAIConfigItem = {
	key: CONFIG_ITEM_KEYS.CONVERT_TO_TABLE,
	title: messages.title,
	description: messages.description,
	icon: ({ shownAt }) => <Icon shownAt={shownAt} />,
	statusLozengeType: 'beta',
	intentSchemaId,
	actions: {
		selection: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
	},
};

export const convertToTableWithOptions: EditorPluginAIConfigItemWithOptions = {
	config: convertToTable,
	triggers: { empty: false, selection: true },
};

// remove this when cleanup platform_editor_ai_remove_selection_type
export const convertToTableRangeConfigItem = createEditorPluginAIConfigItemMarkdown<'range'>({
	key: CONFIG_ITEM_KEYS.CONVERT_TO_TABLE,
	title: messages.title,
	description: messages.description,
	icon: () => <SpreadsheetIcon label="" color={token('color.icon', '#44546F')} />,
	statusLozengeType: 'beta',
	selectionType: 'range',
	intentSchemaId,
	isVisible: ({ editorView, positions }) => isMinLength({ editorView, minLength: 1, positions }),
	getBackendModel: () => 'assistance-service',
	actions: [
		createInsertBelow({ appearance: 'secondary' }),
		createReplace({ appearance: 'primary' }),
	],
});
